"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAdCommentFromPrebidBid = void 0;
/**
 * extracted from ad-config - getAdCommentFromPrebidBid
 * fine to use as-is, matches production, but in a nicer way.
 */
var getAdCommentFromPrebidBid = function (bid) {
    return "p:".concat(bid.bidder, " c:").concat(bid.creativeId, " m:").concat(JSON.stringify(bid.meta));
};
exports.getAdCommentFromPrebidBid = getAdCommentFromPrebidBid;
exports.default = {
    getAdCommentFromPrebidBid: exports.getAdCommentFromPrebidBid,
};
